import { getCookie } from 'react-simple-cookie-store';
import { AccessToken } from './AccessToken';
export var getAccessToken = function () { return getCookie(AccessToken.Access) || ''; };
